import React, {useContext, useEffect} from 'react';
import Header from "../Header/Header";
import {Route, Routes, useNavigate} from "react-router-dom";
import Tasks from "../Tasks/Tasks";
import Task from "../Task/Task";
import TaskCategoryNew from "../TaskCategory/TaskCategoryNew";
import TaskCategoryJob from "../TaskCategory/TaskCategoryJob";
import TaskCategoryRenew from "../TaskCategory/TaskCategoryRenew";
import TaskCategoryGood from "../TaskCategory/TaskCategoryGood";
import NewTask from "../NewTask/NewTask";
import MyTask from "../TaskCategory/MyTask";
import {Context} from "../../index";
import {observer} from "mobx-react-lite";
import AdminPanel from "../AdminPanel/AdminPanel";
import UpdateUser from "../UpdateUser/UpdateUser";
import Chat from "../Chat/Chat";
import useSocketSetup from "./useSocketSetup";
import ModalTaskUpdateShow from "../Modal/ModalTaskUpdateShow";

const Job = () => {

    const {userStore} = useContext(Context)
    const navigate = useNavigate()

    useSocketSetup()

    useEffect(() => {
        if (!userStore.isAuth) {
            navigate('/login')
        }
        if (userStore.user.block) {
            navigate('/blocked')
        }
    }, [userStore.isAuth])

    return (
        <div style={{display: 'flex'}}>
            <Header/>
            <Routes>
                <Route path="/task" element={<Tasks/>}/>
                <Route path="/task/:id" element={<Task/>}/>
                <Route path="/tasks_new" element={<TaskCategoryNew/>}/>
                <Route path="/tasks_job" element={<TaskCategoryJob/>}/>
                <Route path="/tasks_renew" element={<TaskCategoryRenew/>}/>
                <Route path="/tasks_good" element={<TaskCategoryGood/>}/>
                <Route path="/admin_panel" element={<AdminPanel/>}/>
                <Route path="/admin_panel/:id" element={<UpdateUser/>}/>
                <Route path="/newTask" element={<NewTask/>}/>
                <Route path="/myTasks" element={<MyTask/>}/>
                <Route path="/message" element={<Chat/>}/>
            </Routes>

            <ModalTaskUpdateShow/>

        </div>
    );
};

export default observer(Job);